import React from "react";
import { Box, Container, Typography } from "@mui/material";
import SectionHeader from "../UI/SectionHeader";

const experiences = [
  {
    year: "Jan 2025 — Jan 2026",
    role: "Software Developer (Flutter & Odoo)",
    company: "Techleara (Remote)",
    desc: "Engineered cross-platform mobile apps for real estate and HR. Led frontend customization of Odoo modules and integrated APIs, championing clean architecture and Riverpod state management.",
    active: true,
  },
  {
    year: "Jul 2022 — May 2024",
    role: "Frontend Developer (React)",
    company: "GUNSEL-PUNICA",
    desc: "Engineered an intuitive analytics dashboard resulting in a 20% performance improvement. Architected a reusable component library in close collaboration with UI/UX designers during daily agile sprints.",
    active: false,
  },
];

const Experience = () => {
  return (
    <Box id="experience" sx={{ py: 16, bgcolor: "rgba(18, 18, 20, 0.3)" }}>
      <Container maxWidth="lg" sx={{ px: 3 }}>
        <SectionHeader
          number="03"
          title="Experience"
          description="Career Trajectory"
        />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {experiences.map((exp, idx) => (
            <Box
              key={idx}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: 4, md: 10 },
              }}
            >
              <Typography
                sx={{
                  width: { md: 150 },
                  fontFamily: "mono",
                  color: "text.secondary",
                  fontSize: "0.875rem",
                }}
              >
                {exp.year}
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  borderLeft: "1px solid",
                  borderColor: "custom.white10",
                  pl: 4,
                  pb: idx !== experiences.length - 1 ? 6 : 0,
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: 6,
                    left: -4,
                    width: 8,
                    height: 8,
                    bgcolor: exp.active ? "primary.main" : "custom.white20",
                  }}
                />
                <Typography
                  variant="h4"
                  sx={{ fontSize: "1.5rem", fontWeight: 700, mb: 1 }}
                >
                  {exp.role}
                </Typography>
                <Typography
                  sx={{
                    color: exp.active ? "primary.main" : "text.secondary",
                    fontFamily: "mono",
                    fontSize: "0.75rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.1em",
                    mb: 2,
                  }}
                >
                  {exp.company}
                </Typography>
                <Typography
                  sx={{
                    color: "text.secondary",
                    lineHeight: 1.7,
                    maxWidth: "42rem",
                  }}
                >
                  {exp.desc}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Experience;
